module.exports = __webpack_public_path__ + "static/img/payment-fifth-1x.8359db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-fifth-1x.png
// module id = Q9hb
// module chunks = 12